import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import "../../../src/assets/css/home.css";

const VerticalLayout = ({ children }) => {
    return (
        <div className="vertical-layout d-flex flex-column min-vh-100" style={{ background: "#fff", overflow: "hidden" }}>
            {/* Header */}
            <Header />

            {/* Body: Sidebar + Main content */}
            <div className="d-flex flex-grow-1">
                <Sidebar />
                <main className="flex-grow-1 vertical-layout container-fluid">
                    {children}
                </main>
            </div>

            {/* Footer always at bottom */}
            <Footer />
        </div>
    );
};

export default VerticalLayout;
